import { combineReducers } from 'redux'

import session from "./session";

export default combineReducers({
    session
})


// WEBPACK FOOTER //
// ./src/reducers/index.ts